import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Redirect } from 'react-router-dom'
import Cards from './cards/Cards';
import Howto from './howto/Howto';
import More from './more/More';
import Navbar from './navbar/Navbar';
import Message from './message/Message';
import localization from './localization';
import { events, navLinks, messageTimeout } from './config';
import './App.css';

class App extends Component {
    constructor(props) {
        super(props);

        this.onOfflineReady = this.onOfflineReady.bind(this);
        this.onUpdateAvailable = this.onUpdateAvailable.bind(this);
        this.onMessageClose = this.onMessageClose.bind(this);

        this.state = {
            lang: localization.currentLanguage,
            messageVisible: false,
            messageText: ''
        };
    }

    componentWillMount() {
        document.body.addEventListener(localization.langChangeEvent, (e) => {
            this.setState({ lang: e.detail.lang });
        });

        window.addEventListener(events.offlineReady, this.onOfflineReady);

        window.addEventListener(events.updateAvailable, this.onUpdateAvailable);
    }

    onOfflineReady() {
        this.showMessage('message_offlineready');
    }

    onUpdateAvailable() {
        this.showMessage('message_updateavailable');
    }

    onMessageClose() {
        this.setState({ messageVisible: false });
        clearTimeout(this.messageTimeout);
    }

    showMessage(messageText) {
        this.setState({
            messageVisible: true,
            messageText
        });
        this.messageTimeout = setTimeout(() => {
            this.setState({ messageVisible: false });
        }, messageTimeout);
    }

  render() {
      const { messageVisible, messageText } = this.state;
      return (

        <div className="app">
            <Router>
                <div className="main">
            		<Route exact path="/cards/:selectedCard?" component={Cards} />
            		<Route exact path="/howto" component={Howto} />
            		<Route exact path="/more" component={More} />
                    <Route exact path="/" render={() => <Redirect to="/cards"/>}/>

                    <Message
                        visible={messageVisible}
                        text={messageText}
                        onCloseBtnTap={this.onMessageClose}
                    />

                    <Route path="/cards/:selectedCard" exact children={(props) => (
                        <Navbar {...props} navLinks={navLinks} hidden={props.match} />
                    )}/>
                </div>
            </Router>
        </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js